module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "part1"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007toc#p01"
    }
  }, [_vm._v("PART 1"), _c('br'), _vm._v("Obsessive-Christianity"), _c('br'), _vm._v("Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("We may spend our days in what we call our religious duties,"), _c('br'), _vm._v("and we may fill our devotions with fervor, and still may be miserable."), _c('br'), _vm._v("Nothing can set our hearts at rest but a real acquaintance with God.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Hannah Whitall Smith (1832-1911)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc19f21","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010part1.vue
// module id = 81
// module chunks = 0